export const authorisedHome=me=>me?.mode==='presenter'?{area:me.workspaces[0],view:'showcase'}:
  me?.workspaces?.length===1?{area:me.workspaces[0]}:{area:'hub'};

export const routePermitted=(route,me)=>{
  if(!me?.team||route.share||['hub','not-found'].includes(route.area))return true;
  if(['access','ai-services'].includes(route.area))return Boolean(me.admin);
  return Boolean(me.workspaces?.includes(route.area));
};

export const presentationAccess=(me,scope)=>({...me,admin:false,mode:'presenter',role:'presenter',
  account_role:me.account_role||me.role,workspaces:[scope],presentation:true});